import { object, string } from '@gogame/schemas';

import { NAME, AFFECTED_LEVEL, SECONDARY_AFFECTED_LEVEL } from './constants';

export const generalValidationSchema = object({
  [NAME]: string(),
  [AFFECTED_LEVEL]: string().required('Affected level is required'),
  [SECONDARY_AFFECTED_LEVEL]: string(),
});
